import React from 'react';
import {
  GestureResponderEvent,
  ViewStyle,
  TextStyle,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import theme from '../../common/theme';
import Icon from '../Icon/Icon';

export interface IconButtonProps {
  testID?: string;
  icon: string;
  iconSize?: number;
  containerSize?: number;
  onPress?: (event?: GestureResponderEvent) => void;
  danger?: boolean;
  success?: boolean;
  circular?: boolean;
  primary?: boolean;
  secondary?: boolean;
  color?: string;
  fluid?: boolean;
  disabled?: boolean;
  iconStyle?: TextStyle;
  textStyle?: TextStyle;
  containerStyle?: ViewStyle;
  text?: string;
  iconColor?: string;
  onLongPress?: ((event: GestureResponderEvent) => void) | undefined;
}

const IconButton: React.FC<IconButtonProps> = (props: IconButtonProps) => {
  const getBackgroundColor = (): string | undefined => {
    if (!props.color) return undefined;
    const colorValue = theme.colors[props.color as keyof typeof theme.colors];
    // Ensure we only return string colors, not objects like gradient or states
    return typeof colorValue === 'string' ? colorValue : undefined;
  };

  const dynamicStyles = {
    height: props.containerSize,
    width: props.containerSize,
    flex: props.fluid ? 1 : undefined,
    borderRadius: props.circular ? 70 : undefined,
    backgroundColor: getBackgroundColor(),
  };

  return (
    <TouchableOpacity
      testID={props.testID}
      onPress={props.onPress}
      disabled={props.disabled}
      style={[styles.container, dynamicStyles, props.containerStyle]}
      onLongPress={props.onLongPress}
    >
      {props.text && <Text style={props.textStyle}>{props.text}</Text>}
      <Icon
        size={props?.iconSize ?? 24}
        name={props.icon}
        primary={props.primary}
        success={props.success}
        danger={props.danger}
        secondary={props.secondary}
        style={props.iconStyle}
        disabled={props.disabled}
        color={props.iconColor}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default IconButton;
